<template>
  <basic-container>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :page.sync="page"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="onLoad"
    >
      <template slot="attachIdsForm" slot-scope="scope">
        <vUpload :disabled="viewFlag" :limit="10" :fileList.sync="form.fileList"></vUpload>
      </template>
      <template slot="areaNameForm" slot-scope="scope">
        <avue-input-tree  style="width:100%" 
        :props='treeAreaProps' v-model="form.areaId" :disabled="viewFlag" placeholder="请选择存放位置" type="tree" :dic="areaList">
        </avue-input-tree>
        <!-- <div>
          <el-select
            :value="form.areaId"
            placeholder="请选择存放位置"
            clearable
            style="width: 100%;"
            :disabled="viewFlag"
          >
            <el-option :value="form.areaId" show-all-levels :label="form.areaName">
              <el-tree
                node-key="id"
                :data="treeFormAreaData"
                :props="treeProps"
                :load="editAreaLazyLoadTree"
                lazy
                @node-click="editAreaNodeTreeClick"
              >
              </el-tree>
            </el-option>
          </el-select>
        </div> -->
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
  import {add, getDetail, getList, remove, update} from "@/api/crmedical/device/devicepart";
  import {lazyTree,getNodeByProjectId} from "@/api/crmedical/project/area";
  import vUpload from "@/views/components/v-upload";
  import {
  treeByProjectDeptId,
  treeByProjectDeviceTypeId,
  treeByProjectAreaId,
} from '@/api/crmedical/device/device';
  var inputNumber = (rule, value, callback) => {
    if ((typeof value !== 'number' && isNaN(value)) || value <= 0) {
      callback(new Error('请输入大于 0 的数字！'));
    } else {
      callback();
    }
  };
  export default {
    props:['row'],
    components: {
      vUpload
    },
    data() {
      return {
        treeAreaProps: {
        labelText: '标题',
        label: 'title',
        value: 'id',
        children: 'children',
      },
        areaList:[],
        areaNameFlag: true,
        areaIdFlag: false,
        treeFormAreaData: [],
        treeProps: {
          //标题
          label: 'fullName',
          //值
          value: 'id',
          //子节点
          children: 'zones',
          //是否叶子节点
          isLeaf: 'hasChildren',
          //本节点类型key值
          objectType: 'id',
          //本节点类型名
          objectTypeName: 'fullName',
        },
        areaIdList:[],
        form: {fileList:[]},
        query: {},
        loading: false,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        selectionList: [],
        option: {
          align:"left",
          height: 'auto',
          calcHeight: 'auto',
          tip: false,
          border: true,
          index: true,
          viewBtn: true,
          indexLabel: '序号',
          columnBtn: false,
          searchMenuSpan: 18,
          dialogClickModal:false,
          column: [
            {
              label: "项目名称",
              prop: "projectName",
              disabled: true,
              hide: true,
              span: 6,
            },
            {
              label: "项目id",
              prop: "projectId",
              display: false,
              hide: true,
              span: 6,
            },
            {
              label: "设备名称",
              prop: "deviceName",
              disabled: true,
              hide: true,
              span: 6,
            },
            {
              label: "设备id",
              prop: "deviceId",
              display: false,
              hide: true,
              span: 6,
            },
            {
              label: "设备编号",
              prop: "deviceCode",
              disabled: true,
              hide: true,
              span: 6,
            },
            {
              label: "设备类型",
              prop: "typeName",
              disabled: true,
              hide: true,
              span: 6,
            },
            {
              label: "设备类型id",
              prop: "typeId",
              display: false,
              hide: true,
              span: 6,
            },
            {
              label: "配件名称",
              prop: "name",
              rules: [{
                required: true,
                message: "请输入配件名称",
                trigger: "change"
              }],
              span: 6,
              maxlength: 15,
              showWordLimit: true,
              overHidden: true,
              search: true,
            },
            {
              label: "配件编号",
              prop: "code",
              rules: [{
                required: true,
                message: "请输入配件编号",
                trigger: "change"
              }],
              hide: true,
              maxlength: 15,
              showWordLimit: true,
              overHidden: true,
              span: 6,
            },
            {
              label: "配件品牌",
              prop: "brand",
              rules: [{
                required: true,
                message: "请输入配件品牌",
                trigger: "change"
              }],
              hide: true,
              maxlength: 15,
              showWordLimit: true,
              overHidden: true,
              span: 6,
            },
            {
              label: "配件型号",
              prop: "model",
              rules: [{
                required: true,
                message: "请输入配件型号",
                trigger: "change"
              }],
              span: 6,
              maxlength: 15,
              showWordLimit: true,
              overHidden: true,
            },
            {
              label: "生产厂家",
              prop: "provider",
              rules: [{
                required: true,
                message: "请输入生产厂家",
                trigger: "change"
              }],
              span: 6,
              maxlength: 15,
              showWordLimit: true,
              overHidden: true,
            },
            {
              label: "出厂编号",
              prop: "factoryNumber",
              rules: [{
                required: true,
                message: "请输入出厂编号",
                trigger: "change"
              }],
              span: 6,
              maxlength: 15,
              showWordLimit: true,
              overHidden: true,
            },
            {
              label: "出厂时间",
              prop: "factoryOutTime",
              rules: [{
                required: true,
                message: "请输入出厂时间",
                trigger: "change"
              }],
              span: 6,
              type:'date',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
            },
            {
              label: "数量",
              prop: "num",
              rules: [{
                required: true,
                message: "请输入数量",
                trigger: "change"
              },
                {
                  validator: inputNumber,
                  trigger: 'blur',
                },],
              span: 6,
              maxlength: 4,
              showWordLimit: true,
            },
            {
              label: "设备描述",
              prop: "description",
              rules: [{
                required: true,
                message: "请输入设备描述",
                trigger: "change"
              }],
              hide: true,
              display: false,
              span: 6,
            },
            {
              label: "存放位置",
              prop: "areaName",
              formslot: true,
              span: 6,
              hide: true,
            },
            {
              label: "存放位置",
              prop: "areaIdName",
              span: 6,
              display: false,
            },
            {
              label: "备注",
              prop: "remark",
              type: 'textarea',
              maxlength: 200,
              showWordLimit: true,
              overHidden: true,
              span: 24,
            },
            {
              label: '配件附件',
              prop: 'attachIds',
              formslot: true,
              hide: true,
              span: 24,
            },
          ]
        },
        data: [],
        device: {},
        attachIdList: [],
        viewFlag: false,
      };
    },
    computed: {
    },
    mounted(){
      this.option.height = this.bodyHeight - 379;
    },
    created(){
      // console.log("配件的",this.row)
      
     
      //   this.$set(this.form, 'projectId', this.row.projectId);
      //   this.$set(this.form, 'projectName', this.row.$projectId);
        
      //   this.form.deviceId = this.row.id;
      //   this.$set(this.form, 'deviceName', this.row.name);
      //   this.form.typeName = this.row.typeName;
      //   this.form.deviceCode = this.row.code;
      
      
      // console.log(this.form)
    },
    methods: {
      getAreaList(value) {
        treeByProjectAreaId({ projectId: value }).then((res) => {
          this.areaList = res.data;
        });
      },
      editAreaLazyLoadTree(node, resolve) {
        let id;
        if (node.level === 0) {
          id = 0;
        } else {
          id = node.data.id;
        }
        getNodeByProjectId({projectId: this.form.projectId}).then(({ data }) => {
          if (data instanceof Array ) {
            data.forEach(item => {
              item.hasChildren = !item.hasChildren;
            })
          }
          resolve(data);
        });
      },
      editAreaNodeTreeClick(node){
        let nodeId = node.id;
        let nodeTitle = node.fullName;
        this.form.areaName = nodeTitle;
        this.form.areaId = nodeId;
        this.areaNameFlag = true;
        this.areaIdFlag =false;
      },
      fileHandleRemove(file, fileList) {
        let delAttachId ;
        if(file.response){
          delAttachId = file.response.data.id;
        } else {
          delAttachId = file.id;
        }
        let index = this.attachIdList.indexOf(delAttachId);
        this.attachIdList.splice(index, 1);
        this.form.attachIds = this.attachIdList.join(',');
      },
      fileUploadSuccess(response, file, fileList) {
        this.attachIdList.push(response.data.id);
        this.form.attachIds = this.attachIdList.join(',');
      },
      rowSave(row, loading, done) {
        console.log(row);
        let props = [];
        this.option.column.forEach(ele=>{
            props.push(ele.prop);
        })
        let param = {};
        props.forEach(ele=>{
          param[ele] = row[ele];
        })
        let fileList = row.fileList;
        console.log("fileList:"+fileList);
        if(fileList){
          let str = '';
          fileList.forEach((value,index)=>{
            if(fileList.length-1 === index){
              str = str + value.id;
            }else {
              str = str + value.id + ',';
            }
          });
          console.log("str:"+str);
          row.attachIds = str;
          param.attachIds = str;
        }
        param.areaId = row.areaId;
        param.deptId = row.deptId;
        param.typeId = this.row.typeId;
        param.deviceId = row.id;
        param.projectId = this.row.projectId;
      

        add(param).then(() => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        }, error => {
          done();
          console.log(error);
        });
      },
      rowUpdate(row, index, loading, done) {
        update(row).then(() => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        }, error => {
          done();
          console.log(error);
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: this.ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        console.log(this.form.attachIds)
        this.getAreaList(this.row.projectId)
        this.form.attachIds = '';
        this.attachIdList = [];
        this.viewFlag = false;
        if(type === 'add'){
          // this.form.projectId = this.device.projectId;
          let obj = Object.assign({},this.row)
          obj.name = ''
          obj.code = ''
          obj.brand = ''
          obj.provider=''
          obj.model = ''
          this.form=obj
          this.$set(this.form,'projectName','this.row.$projectId')
          
          // this.form.projectName = this.row.$projectId
          
          
          this.form.deviceId = this.row.id
          this.$forceUpdate();
          console.log("row:",this.row)
          setTimeout(()=>{
            this.defaultValue();
            this.$set(this.form,'projectName',this.row.$projectId)
            this.form.deviceName = this.row.name
            this.form.deviceCode = this.row.code
            this.form.typeName = this.row.typeName
           
            this.form.attachIds = '';
            this.attachIdList = [];
            this.$set(this.form,'fileList',[])
            // this.form.fileList = [];
          },10)
        }
        if(type === 'view'){
          this.viewFlag = true;
        }
        if (["edit", "view"].includes(type)) {
          getDetail({id: this.form.id}).then(({data}) => {
            this.form = data;
            this.attachIdList = data.longs;
          });
        }
        done();
      },
      defaultValue(){
        this.form.projectName = this.device.$projectId;
        this.form.projectId = this.device.projectId;
        this.form.deviceId = this.device.id;
        this.form.deviceName = this.device.name;
        this.form.deviceCode = this.device.code;
        this.form.typeName = this.device.typeName;
        this.form.typeId = this.device.typeId;
      },
      searchReset() {
        this.query = {};
        this.query.deviceId = this.device.id;
        this.onLoad();
      },
      searchChange(params,done) {
        this.query = params;
        this.query.deviceId = this.device.id;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      openPart(record){
        this.device = record;
        this.query.deviceId = this.device.id;
        this.onLoad();
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        this.query.deviceId = this.row.id;
        getList(
          Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
        ).then(({data}) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }).catch(()=>{
          this.loading = false;
        })
      },

    }
  };
</script>

<style scoped>
::v-deep .avue-form__menu--center{
    text-align: right;
  }
 ::v-deep .avue-crud__search .el-form-item--small.el-form-item{
    width: 100%;
  }
</style>
